import { useQueryClient } from 'react-query';
import { REPRESENTATIVES_QUERY_STRING } from 'shared/constants/REPRESENTATIVES_QUERY_STRING';
/**
 * Custom hook to invalidate profile queries in React Query.
 * This is useful when you want to reset or refetch profile-related data.
 *
 * @returns {Function} A function that takes an array of query keys to invalidate.
 */
export const useInvalidateProfile = () => {
  const queryClient = useQueryClient();

  const invalidateProfile = (queryKeys: string[]) => {
    queryClient.resetQueries(queryKeys);
  };

  const invalidateMultipleProfileResume = () => {
    const queries = queryClient
      .getQueryCache()
      .getAll()
      .filter((query) => {
        const key = query.queryKey;

        return Array.isArray(key) && key.includes(REPRESENTATIVES_QUERY_STRING.representatives_single_profile_resume);
      });

    queries.map((queryKey) => invalidateProfile(queryKey.queryKey as string[]));
  };

  return { invalidateProfile, invalidateMultipleProfileResume };
};
